import { Loader } from '@carboncopyco/ui';
/* eslint-disable no-console */
import { type ReactNode, useEffect } from 'react';
import { APP_MODAL_Z_INDEX } from '../constants';
import rendererService from '../services/RendererService';
import { isOnline } from '../shared/utils';
import { useUser } from '../store/context';

async function updateOnlineStatus() {
  console.info('online status changed, is online', navigator.onLine);
  let onlineStatus;
  try {
    onlineStatus = await isOnline();
  } catch (e) {
    onlineStatus = false;
    console.info('electron onlineStatus is still undefined', e);
  }
  if (navigator.onLine && onlineStatus) {
    const isAuthenticated = await window.dsDesktop?.user?.isAuthenticated();
    console.info('isAuthenticated ', isAuthenticated);
  }
}

export const AppLoader = ({ children }: { children: ReactNode }) => {
  const { isLoadingApp, setIsLoadingApp } = useUser();
  useEffect(() => {
    if (isLoadingApp) {
      rendererService.focusApp();
    }
  }, [isLoadingApp]);
  const loaderEventListener = () => {
    window.dsDesktop?.navigation.onSetLoader((message) => {
      setIsLoadingApp(message.isLoading);
    });
    window.addEventListener('online', updateOnlineStatus);
    window.addEventListener('offline', updateOnlineStatus);
  };

  useEffect(() => {
    loaderEventListener();
    return () => {
      window.removeEventListener('online', updateOnlineStatus);
      window.removeEventListener('offline', updateOnlineStatus);
    };
  }, []);

  return isLoadingApp ? (
    <div
      data-testid="appLoader"
      className={`absolute inset-0 w-full h-full z-${APP_MODAL_Z_INDEX + 1}`}
    >
      <Loader show />
    </div>
  ) : (
    <>{children}</>
  );
};
